import { OTHER_SCOPE_GROUP, SCOPE_EDIT_SUFFIXES, SCOPE_GROUPS } from 'constants/scopes';
import { ScopeGroupPermissionType, ScopeGroupsByPermission } from 'types/scopes';

export const getScopeGroupsByPermissionType = (scopes: string[]): ScopeGroupsByPermission => {
  const scopesByPermissionType: ScopeGroupsByPermission = {
    [ScopeGroupPermissionType.View]: [],
    [ScopeGroupPermissionType.Edit]: [],
  };

  scopes.forEach((scope) => {
    const isScopeReadOnly: boolean = !SCOPE_EDIT_SUFFIXES.find((editSuffix) =>
      scope.includes(editSuffix)
    );
    let scopeFoundInGroups: boolean = false;

    SCOPE_GROUPS.forEach((scopeGroup) => {
      if (scopeGroup.scopes.indexOf(scope) >= 0) {
        if (isScopeReadOnly) {
          if (
            !scopesByPermissionType[ScopeGroupPermissionType.View].find(
              (group) => group.name === scopeGroup.name
            )
          ) {
            scopesByPermissionType[ScopeGroupPermissionType.View].push({
              name: scopeGroup.name,
              scopes: [],
            });
          }

          scopesByPermissionType[ScopeGroupPermissionType.View]
            .find((group) => group.name === scopeGroup.name)
            ?.scopes.push(scope);
          scopeFoundInGroups = true;
        } else {
          if (
            !scopesByPermissionType[ScopeGroupPermissionType.Edit].find(
              (group) => group.name === scopeGroup.name
            )
          ) {
            scopesByPermissionType[ScopeGroupPermissionType.Edit].push({
              name: scopeGroup.name,
              scopes: [],
            });
          }

          scopesByPermissionType[ScopeGroupPermissionType.Edit]
            .find((group) => group.name === scopeGroup.name)
            ?.scopes.push(scope);
          scopeFoundInGroups = true;
        }
      }
    });

    if (!scopeFoundInGroups) {
      if (isScopeReadOnly) {
        if (
          !scopesByPermissionType[ScopeGroupPermissionType.View].find(
            (group) => group.name === OTHER_SCOPE_GROUP
          )
        ) {
          scopesByPermissionType[ScopeGroupPermissionType.View].push({
            name: OTHER_SCOPE_GROUP,
            scopes: [],
          });
        }

        scopesByPermissionType[ScopeGroupPermissionType.View]
          .find((group) => group.name === OTHER_SCOPE_GROUP)
          ?.scopes.push(scope);
      } else {
        if (
          !scopesByPermissionType[ScopeGroupPermissionType.Edit].find(
            (group) => group.name === OTHER_SCOPE_GROUP
          )
        ) {
          scopesByPermissionType[ScopeGroupPermissionType.Edit].push({
            name: OTHER_SCOPE_GROUP,
            scopes: [],
          });
        }

        scopesByPermissionType[ScopeGroupPermissionType.Edit]
          .find((group) => group.name === OTHER_SCOPE_GROUP)
          ?.scopes.push(scope);
      }
    }
  });

  // make sure that 'Other' group is always last in both permission types
  const sortedScopesByPermissionType: ScopeGroupsByPermission = {
    [ScopeGroupPermissionType.View]: [
      ...scopesByPermissionType[ScopeGroupPermissionType.View].filter(
        (item) => item.name !== OTHER_SCOPE_GROUP
      ),
      ...scopesByPermissionType[ScopeGroupPermissionType.View].filter(
        (item) => item.name === OTHER_SCOPE_GROUP
      ),
    ],
    [ScopeGroupPermissionType.Edit]: [
      ...scopesByPermissionType[ScopeGroupPermissionType.Edit].filter(
        (item) => item.name !== OTHER_SCOPE_GROUP
      ),
      ...scopesByPermissionType[ScopeGroupPermissionType.Edit].filter(
        (item) => item.name === OTHER_SCOPE_GROUP
      ),
    ],
  };

  return sortedScopesByPermissionType;
};
